import Flex from '@Components/Bases/Flex';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { Chip } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type TagsProps = {
  name: string;
  disabled?: boolean;
};

const Tags = ({ name, disabled }: TagsProps) => {
  const { getValues, setValue } = useFormContext();
  const value = getValues(name) || [];

  const handleDeleteTag = (stakeholder: IInfoCategoryMasterData) => {
    setValue(
      name,
      value.filter(
        (item: IInfoCategoryMasterData) => item.nameTh !== stakeholder.nameTh
      )
    );
  };

  return (
    <Flex gap={1} flexWrap={'wrap'} mb={value.length ? 1 : 0}>
      {value.map((item: IInfoCategoryMasterData) => (
        <Chip
          key={item.infoCategoryMasterDataId}
          label={item.nameTh}
          onDelete={disabled ? undefined : () => handleDeleteTag(item)}
          sx={{
            '& .MuiChip-deleteIcon': {
              display: disabled ? 'none' : 'block',
            },
          }}
        />
      ))}
    </Flex>
  );
};

export default Tags;
